import floor from 'lodash/floor';
import type {AudioPlayerObject} from '@Libraries/audio-player/audio-player.types';

export function getTrimmedDuration(audioPlayerObject: AudioPlayerObject): number {
	if (audioPlayerObject.trim.isTrimmed) {
		return audioPlayerObject.trim.endTime - audioPlayerObject.trim.startTime;
	}

	return audioPlayerObject.originalDuration;
}

export function getTrimmedPlaybackDuration(audioPlayerObject: AudioPlayerObject): number {
	return getTrimmedDuration(audioPlayerObject) / audioPlayerObject.speed;
}

export function getPlaybackDuration(audioPlayerObject: AudioPlayerObject): number {
	return getTrimmedPlaybackDuration(audioPlayerObject);
}

export function getMaxFadeDuration(audioPlayerObject: AudioPlayerObject): number {
	if (getPlaybackDuration(audioPlayerObject) < 2) {
		return 0;
	}

	return floor(getPlaybackDuration(audioPlayerObject) / 2, 2);
}

export function getTrimmedStartTime(audioPlayerObject: AudioPlayerObject): number {
	return audioPlayerObject.trim.isTrimmed ? audioPlayerObject.trim.startTime : 0;
}

export function getTrimmedEndTime(audioPlayerObject: AudioPlayerObject): number {
	return audioPlayerObject.trim.isTrimmed ? audioPlayerObject.trim.endTime : audioPlayerObject.originalDuration;
}
